import en from './en.json' with { type: 'json' };

type TranslationTree = { [key: string]: string | TranslationTree };

function flatten(tree: TranslationTree, prefix = '', out: Record<string, string> = {}) {
  for (const [key, value] of Object.entries(tree)) {
    const path = prefix ? `${prefix}.${key}` : key;
    if (typeof value === 'string') {
      out[path] = value;
    } else {
      flatten(value, path, out);
    }
  }
  return out;
}

export const DEFAULT_TRANSLATIONS: Record<string, string> = flatten(en);

export const TRANSLATION_KEY_OPTIONS = Object.keys(DEFAULT_TRANSLATIONS).map((key) => ({
  value: key,
  label: key,
}));
